import React from 'react';
export function Header() {
  return <div className="bg-white border-b border-gray-200" data-id="element-327">
      <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-328">
        <div className="text-sm text-gray-600 font-medium" data-id="element-329">
          Health & Beauty | Advertorial
        </div>
      </div>
    </div>;
}